import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import Logo from "./Logo";
import { SITE, NAV_LINKS, COMPENSATION_DISCLOSURE, EMERGENCY_NOTE } from "../lib/site";

export default function Footer() {
  return (
    <footer className="bg-forest text-ivory grain">
      <div className="mx-auto max-w-site px-4 py-16 sm:px-6 lg:px-12 lg:py-20">
        <div className="grid gap-12 md:grid-cols-12">
          <div className="md:col-span-5">
            <Logo dark />
            <p className="mt-6 max-w-sm font-serif text-xl italic leading-relaxed text-ivory/85">
              {SITE.proposition}
            </p>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-ivory/60">
              Curated, not just listed. Personally vetted senior care guidance across{" "}
              {SITE.area}.
            </p>
          </div>

          <nav className="md:col-span-3" aria-label="Footer">
            <h2 className="text-[0.7rem] font-semibold uppercase tracking-[0.18em] text-sage">
              Explore
            </h2>
            <ul className="mt-5 space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    data-testid={`footer-link-${l.to.replace("/", "")}`}
                    className="text-[0.95rem] text-ivory/80 transition-colors hover:text-clay"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
              <li>
                <Link
                  to="/family-experiences"
                  data-testid="footer-link-family-experiences"
                  className="text-[0.95rem] text-ivory/80 transition-colors hover:text-clay"
                >
                  Family Experiences
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  data-testid="footer-link-contact"
                  className="text-[0.95rem] text-ivory/80 transition-colors hover:text-clay"
                >
                  Contact
                </Link>
              </li>
            </ul>
          </nav>

          <div className="md:col-span-4">
            <h2 className="text-[0.7rem] font-semibold uppercase tracking-[0.18em] text-sage">
              Contact
            </h2>
            <ul className="mt-5 space-y-4 text-[0.95rem]">
              <li>
                <a
                  href={SITE.phoneHref}
                  data-testid="footer-phone"
                  className="inline-flex items-center gap-2.5 text-ivory/80 transition-colors hover:text-clay"
                >
                  <Phone className="h-4 w-4 text-clay" aria-hidden="true" />
                  {SITE.phoneDisplay}
                </a>
              </li>
              <li>
                <a
                  href={`mailto:${SITE.email}`}
                  data-testid="footer-email"
                  className="inline-flex items-center gap-2.5 text-ivory/80 transition-colors hover:text-clay"
                >
                  <Mail className="h-4 w-4 text-clay" aria-hidden="true" />
                  {SITE.email}
                </a>
              </li>
              <li className="flex items-center gap-2.5 text-ivory/80">
                <MapPin className="h-4 w-4 text-clay" aria-hidden="true" />
                {SITE.area}
              </li>
            </ul>
            <p className="mt-8 font-serif text-lg italic text-clay">{SITE.tagline}</p>
          </div>
        </div>

        <div className="mt-14 border-t border-ivory/10 pt-8">
          <p className="max-w-3xl text-[0.8rem] leading-relaxed text-ivory/55">
            {COMPENSATION_DISCLOSURE}
          </p>
          <p className="mt-3 max-w-3xl text-[0.8rem] leading-relaxed text-ivory/55">
            {EMERGENCY_NOTE}
          </p>
          <div className="mt-6 flex flex-wrap items-center gap-x-6 gap-y-3 text-[0.8rem]">
            <Link to="/privacy" data-testid="footer-link-privacy" className="text-ivory/70 underline-offset-4 hover:text-clay hover:underline">
              Privacy Policy
            </Link>
            <span className="text-ivory/40">
              © {new Date().getFullYear()} CareCraft. All rights reserved.
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}
